import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { KoanIndexCardStackBackgroundViewModel } from './koan-index-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';

@Component({
  selector: 'app-koan-index-card-stack-background',
  templateUrl: './koan-index-card-stack-background.component.html',
  styleUrls: ['./koan-index-card-stack-background.component.scss'],
  providers: [KoanIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class KoanIndexCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: KoanIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
